import { AmplifyCore, commonEnums as enums } from '@codametrix/ui-common';

/**
 * Also gates the /cmx/prioritize/ route (apps/cmx/CMx.tsx). The UI must enforce this because the
 * service-desk API layer gates on JWT roles, not on CMx resources (CDMX-14857).
 *
 * Read from live state on every render, never captured: the worklist stays mounted across
 * service-line switches, so a snapshot goes stale exactly when the answer changes.
 */
export const selectCanPrioritize = (state: any): boolean => {
  const activeContext = state?.ui?.context?.activeContext;
  const serviceLine = state?.ui?.serviceLine?.name ?? '';

  return (
    !!activeContext &&
    AmplifyCore.benchEditable.isResourceAllowed(
      activeContext,
      enums.ResourceId.QUEUE_PRIORITY_ORDER,
      serviceLine
    )
  );
};
